import { memo } from 'react';
import styled, { keyframes } from 'styled-components';

const BaseSpinner = () => {
  return (
    <SpinnerWrapper>
      <Spinner />
    </SpinnerWrapper>
  );
};

export const rotate = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

export const SpinnerWrapper = styled.div``;

export const Spinner = styled.div`
  border: 5px solid #f3f3f3;
  border-top: 5px solid rgb(251, 206, 55);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: ${rotate} 2s linear infinite;
`;

export default memo(BaseSpinner);
